// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"678":"87180aae71ae74eff9c7","731":"7d3e891cb711c795147d","843":"7c9ed3fbc49037d69e77","883":"6497f7664cefd7dcd219"}[chunkId] + ".js";
};